'use client';

import React__default, { useRef, useState, useEffect } from 'react';
import { ScorePercentWrapper, CircleItem, LabelPercent, LabelExtend } from './AICircleProgressBar.css.js';
import { DEFAULT_OPTIONS } from './constants.js';
import { deepMerge } from '../Utils/helpers.js';
import '../_virtual/_tslib.js';
import 'react-dom';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import useElementOnScreen from '../Utils/hooks/UseElementOnScreen/index.js';
import CountUp from '../TextCountUp/index.js';
import { calculatePiece } from './helpers.js';

var circlePercent = 100; // Total percent of a circle
var circleRadius = 360; // Total radius of a circle
var AICircleProgressBar = function (props) {
    var options = props.options;
    var mergedOptions = deepMerge(DEFAULT_OPTIONS, options);
    var divRef = useRef(null);
    var pieces = mergedOptions.pieceCount;
    var _a = useState(0), percent = _a[0], setPercent = _a[1];
    var isElementOnScreen = useElementOnScreen({
        target: divRef,
        options: {
            rootMargin: '0px 0px 0px 0px'
        }
    })[0];
    useEffect(function () {
        if (!isElementOnScreen) {
            return;
        }
        setTimeout(function () { return setPercent(props.percent > circlePercent ? circlePercent : props.percent); }, 500);
    }, [props.percent, isElementOnScreen]);
    var radius = mergedOptions.radius / 2 - mergedOptions.strokeWidth / 2;
    // Total Perimeter in pixel of circle
    var perimeter = Math.PI * 2 * radius;
    var piecesPerimeter = perimeter / pieces;
    // Convert SegmentSpace into radius
    var segmentSpacing = (mergedOptions.segmentSpace * circleRadius) / perimeter;
    // Calculate the dash length for each piece by subtracting
    //   the segment spacing and stroke width from the total perimeter
    var totalDashPerimeter = piecesPerimeter - segmentSpacing - mergedOptions.strokeWidth;
    var anglePiece = 360 / pieces;
    // Calculate the dash length for each piece by subtracting
    //   the segment spacing and stroke width from the total perimeter
    var dash = piecesPerimeter - segmentSpacing - mergedOptions.strokeWidth;
    return (React__default.createElement(ScorePercentWrapper, { ref: divRef, diameter: mergedOptions.radius },
        React__default.createElement("svg", { viewBox: "-".concat(mergedOptions.radius / 2, " -").concat(mergedOptions.radius / 2, " ").concat(mergedOptions.radius, " ").concat(mergedOptions.radius), role: 'presentation' },
            Array.from({ length: pieces }).map(function (_, index) {
                // Calculate the angle for each piece. The base angle (index * 90)
                //    aligns each piece correctly in a square formation,
                //    offset by -90 degrees to start from the top, and adjusted by the segment spacing
                var angle = index * anglePiece - 90 + segmentSpacing;
                return (React__default.createElement(CircleItem, { key: "piece-item-bg-".concat(index), r: radius, cx: '0', cy: '0', strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, perimeter: perimeter, strokeDashoffset: 0, stroke: '#f4f4f7', delay: 0, style: {
                        strokeDasharray: "".concat(dash, "px, ").concat(perimeter, "px"),
                        transform: "rotate(".concat(angle, "deg)")
                    }, duration: mergedOptions.duration }));
            }),
            Array.from({ length: pieces }).map(function (_, index) {
                // Calculate the angle for each piece. The base angle (index * 90)
                //    aligns each piece correctly in a square formation,
                //    offset by -90 degrees to start from the top, and adjusted by the segment spacing
                var angle = index * anglePiece - 90 + segmentSpacing;
                var dash = calculatePiece({
                    percent: percent,
                    perimeter: perimeter,
                    index: index,
                    piecePerimeter: totalDashPerimeter,
                    piecePercent: 100 / pieces
                });
                var color = '#FDB92E';
                if (index === 1) {
                    color = '#FF6200';
                }
                else if (index === 2) {
                    color = '#FF3C68';
                }
                else if (index === 3) {
                    color = '#B900F6';
                }
                return (React__default.createElement(CircleItem, { key: "piece-item-fg-".concat(index), r: radius, cx: '0', cy: '0', stroke: color, strokeLinecap: 'round', strokeWidth: mergedOptions.strokeWidth, perimeter: perimeter, strokeDashoffset: dash, delay: index * mergedOptions.duration, duration: mergedOptions.duration, style: {
                        transform: "rotate(".concat(angle, "deg)")
                    } }));
            })),
        React__default.createElement(LabelPercent, { color: mergedOptions.color, sizes: mergedOptions.radius, label: mergedOptions.label },
            React__default.createElement(CountUp, { start: 0, end: percent, duration: mergedOptions.duration * pieces }),
            "%",
            mergedOptions.label.extend ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("br", null),
                React__default.createElement(LabelExtend, null, mergedOptions.label.extend))) : null)));
};

export { AICircleProgressBar as default };
//# sourceMappingURL=index.js.map
